import React from 'react'
import { connect } from 'react-redux'
import {  Row, Modal, Button } from 'react-bootstrap'

import DashboardFormControl from '../../../components/DashboardFormControl'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../../messages'

import { fetchLicensesByActivationCode, updateLicense, resetSearchResults } from '../../../actions/license-actions'

class LicenseBlock extends React.Component {

    constructor() {
        super()
        this.state = { query: undefined, license:undefined, showModal: false, message : '' }
      }
    
      componentDidMount() {
        if(!this._isUnmounted) {
            if(this.props.results.query) {
              this.setState({ query: this.props.results.query })
            }
            if(this.props.results.length) {
              this.setState({ license: this.props.results[0] })
            }
            if(this.props.showModal) {
              this.setState({ showModal: this.props.showModal })
            }
        }
      }

    componentWillUnmount() {
      this._isUnmounted = true;
      if (this.props.results.length > 0 && this.props.resetSearchResults) {
        this.props.resetSearchResults(); // Clear search results on unmount
      }
    }

      onSearch(query) {
        this.setState({ query })
        this.props.fetchLicensesByActivationCode(query)
      }


      onConfirm(){
        this.setState({showModal: false})
        this.state.license.blocked = !this.state.license.blocked
        this.props.updateLicense(this.state.license)
      }

      onCancel(){
        this.setState({showModal: false})
      }

      render() {


        return <div className='content-licenseAdjustDeactivateBefore' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='key' 
              text=" Licentie blokkeren" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
              Zoek licenties op basis de activatiecode
                </div>
                <DashboardFormControl style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="BOOM-XXXX-XXXX"
                value={this.state.query || this.props.results.query}
                callback={(query) => this.onSearch(query)}
                />
              </div>
              <div>
                  <Modal show={ this.state.showModal } onHide={ () => this.onCancel() }>
                    <Modal.Header>
                      <Modal.Title>Bevestiging</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <span>{ this.props.message}</span>
                    </Modal.Body>

                    <Modal.Footer>
                      <Button bsStyle='danger' onClick={ () => this.onCancel() } id='cancel'>Annuleren</Button>
                      <Button bsStyle='success' onClick={ () => this.onConfirm() } id='confirm'>Doorgaan</Button>
                    </Modal.Footer>
                  </Modal>
              </div>
          </Row>
          </Row>
        </div>
      }

    
}

let SearchInfo = () => (
    <div>
      <p>{SEARCH_INSTRUCTIONS}</p>
      <p>Zoek op:</p>
      <ul>
        <li>License Activatiecode</li>
      </ul>
      <p>{NO_SEARCH_RESULTS}</p>
    </div>
  )

  export default connect((state) => {
    console.log(state)
    const showModalBool = state.licenses.searchResults.length ? true : false;
    const message = showModalBool && state.licenses.searchResults[0].blocked ? 'De licentie is geblokkeerd.' : 'De licentie is gedeblokkeerd.'
    return {
    results: state.licenses.searchResults,
    showModal:showModalBool,
    message: message
   }}, {
    fetchLicensesByActivationCode,
    updateLicense,
    resetSearchResults,
  })(LicenseBlock)
